/* ============================================================
   AXE DESIGN — custom theme JS
   Mobile drawer toggle, qty stepper, active nav, cart count sync.
   Cart drawer + add-to-cart functionality is handled by Horizon's
   web components (cart-drawer-component, add-to-cart-component).
   ============================================================ */
(function () {
  'use strict';

  /* ---------- mobile drawer ---------- */
  function initDrawer() {
    var burger = document.querySelector('[data-axe-burger]');
    var drawer = document.querySelector('[data-axe-drawer]');
    if (!burger || !drawer) return;

    function close() {
      burger.classList.remove('is-open');
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    function open() {
      burger.classList.add('is-open');
      drawer.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    burger.addEventListener('click', function () {
      if (burger.classList.contains('is-open')) close(); else open();
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') close();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 920) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- mark active nav by current path ---------- */
  function initActiveNav() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    document.querySelectorAll('[data-axe-nav] a[href]').forEach(function (a) {
      var href = a.getAttribute('href').replace(/\/+$/, '') || '/';
      if (href !== '/' && (path === href || path.indexOf(href + '/') === 0)) {
        a.classList.add('is-active');
      } else if (href === '/' && path === '/') {
        a.classList.add('is-active');
      }
    });
  }

  /* ---------- cart drawer trigger fallback ----------
     Horizon's on:click="#axe-cart-drawer/open" handles this once cart-drawer.js
     loads. This fallback covers the brief window before the ES module finishes
     loading (and any case where the upgrade hasn't completed yet). */
  function initCartTrigger() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-axe-cart-trigger]');
      if (!trigger) return;
      var drawer = document.getElementById('axe-cart-drawer');
      if (!drawer) return;
      // If the custom element has been upgraded, call its open() directly.
      if (typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open();
        return;
      }
      // Otherwise, wait for the upgrade (cart-drawer.js loads as a module), then open.
      if (window.customElements) {
        e.preventDefault();
        customElements.whenDefined('cart-drawer-component').then(function () {
          if (typeof drawer.open === 'function') drawer.open();
        });
      }
    }, true);
  }

  /* ---------- cart count: sync from Shopify cart on load + on cart events ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-axe-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = String(count);
    });
  }
  function fetchCartCount() {
    if (!window.fetch) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) updateCartCount(cart.item_count); })
      .catch(function () { /* noop */ });
  }
  function initCartCount() {
    fetchCartCount();
    // Horizon fires CartAddEvent / CartUpdateEvent on the document
    ['cart:added', 'cart:update', 'CartUpdate', 'CartAdd'].forEach(function (evt) {
      document.addEventListener(evt, fetchCartCount);
    });
  }

  /* ---------- simple qty stepper (used when not inside an add-to-cart-component) ---------- */
  function initQtySteppers() {
    document.querySelectorAll('[data-axe-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"]');
      var minus = wrap.querySelector('[data-axe-qty-minus]');
      var plus = wrap.querySelector('[data-axe-qty-plus]');
      if (!input || !minus || !plus) return;
      minus.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      plus.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- product gallery: thumb switch + click-to-enlarge ---------- */
  function getLightbox() {
    var lb = document.getElementById('axe-lightbox');
    if (lb) return lb;
    lb = document.createElement('div');
    lb.id = 'axe-lightbox';
    lb.className = 'axe-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Enlarged product image');
    lb.innerHTML =
      '<button type="button" class="axe-lightbox__close" aria-label="Close">&times;</button>' +
      '<img alt="" data-axe-lightbox-img>';
    document.body.appendChild(lb);

    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('.axe-lightbox__close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    lb._close = close;
    return lb;
  }
  function openLightbox(src) {
    if (!src) return;
    var lb = getLightbox();
    lb.querySelector('[data-axe-lightbox-img]').src = src;
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function initProductGallery() {
    document.querySelectorAll('[data-axe-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('.axe-gallery__main');
      var mainImg = main ? main.querySelector('img') : null;

      gallery.querySelectorAll('[data-axe-thumb]').forEach(function (thumb) {
        function activate() {
          if (!mainImg) return;
          var full = thumb.getAttribute('data-full');
          if (full) {
            mainImg.src = full;
            mainImg.removeAttribute('srcset');
          }
          if (main) main.setAttribute('data-zoom-src', thumb.getAttribute('data-zoom') || full || '');
          gallery.querySelectorAll('[data-axe-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }
        thumb.addEventListener('click', activate);
        thumb.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
        });
      });

      if (main) {
        function zoom() { openLightbox(main.getAttribute('data-zoom-src')); }
        main.addEventListener('click', zoom);
        main.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); zoom(); }
        });
      }
    });
  }

  /* ---------- accordion default-open guard (FAQ rows) ---------- */
  // Native <details> handles this; nothing to wire.

  function init() {
    initDrawer();
    initActiveNav();
    initCartTrigger();
    initCartCount();
    initQtySteppers();
    initProductGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
